define('app/views/deal_vendor_phone_number_view',['app/setup'], function (takhfifan) {
  takhfifan.DealVendorPhoneNumberView = Backbone.View.extend({
    events: {
      'click .show-phone-number': 'showPhoneNumber'
    },

    initialize: function () {
      this.productId = $(this.$el).data("product-id");
    },


    showPhoneNumber: function () {
      var phoneNo = $('#show-phone-no').val();
      $('.show-phone-number').css('display', 'none');
      $('.value-phone-number').css('display', 'inline-block').append(phoneNo);

      this.phoneTrackerSubmit();
    },


    phoneTrackerSubmit: function () {
      var url = "/ajax/tracking/log?product_id=" + this.productId;
      $.ajax({
        type: 'GET',
        url: url
      }).done(function (response) {}).fail(function (err) {});
    }

  });
});

